import React from 'react';
import { CTAButton } from '../CTAButton';
export function HowToGet() {
  return <div className="space-y-6" data-id="element-205">
      <h2 className="text-3xl font-bold text-gray-900" data-id="element-206">
        How to Get It (And Save 64%)
      </h2>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-207">
        You can purchase this micro-infusion device directly from the
        manufacturer's website at the best price.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-208">
        They're currently running a special promotion:
      </p>
      <div className="bg-green-50 border-2 border-green-500 rounded-lg p-6 text-center space-y-2" data-id="element-209">
        <p className="text-2xl font-bold text-green-800" data-id="element-210">
          New Customers Save 64% with FREE Shipping!
        </p>
      </div>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-211">
        Plus, every order comes with their 30-day "Full Results" money-back
        guarantee.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-212">
        All orders also come with their "Complete Satisfaction" guarantee—use
        the entire device for the full month as directed, and if you're not
        satisfied with your results, they'll still refund your purchase.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-213">
        Simply put, you'll either love this device, or you get your money back.
        No questions asked.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed italic" data-id="element-214">
        (Even if you've used it for the full treatment cycle!)
      </p>
    </div>;
}